/*
 * @Author: Theo Lin 
 * @Date: 2017-11-09 17:48:32 
 * @Last Modified by: Theo Lin 
 * @Last Modified time: 2017-11-09 17:48:32 
 */

var cookie = {
    get: function get(cname) {
        // cname = 'CH' + cname
        var arr,
            reg = new RegExp("(^| )" + cname + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) {
            return decodeURI(arr[2]);
        }
        return null;
    },
    set: function set(name, value, expHour) {
        // name = 'CH' + name
        var date = new Date();
        date.setTime(date.getTime() + expHour * 60 * 60 * 1000);
        var expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + encodeURI(value) + "; " + expires + ';path=/';
    },
    clear: function clear(name) {
        this.set(name, "", -1);
    }
};
cookie.setMutilValues = function (values, expHour) {
    if (!values) {
        return;
    }
    for (var key in values) {
        if (key) {
            this.set(key, values[key], expHour);
        }
    }
};
cookie.clearMutilKeys = function (keys, expHour) {
    if (!keys) {
        return;
    }
    for (var k in keys) {
        if (keys[k]) {
            cookie.clear(keys[k]);
        }
    }
};

export default cookie;


//////////////////
// WEBPACK FOOTER
// ./assets/js/cookie.js
// module id = ./assets/js/cookie.js
// module chunks = 0 1 2 4 5